import * as React from 'react';
import { routes } from '../../../../../config/routes';
import { Logo } from '../../../../../components/app/logo/logo';
import { HeaderBackButton } from '../../../../../components/app/header/back-button/header-back-button';
import { HeaderPinSharedPortfolioButton } from '../../../../../components/app/header/pin-shared-portfolio-button/header-pin-shared-portfolio-button';

export const HeaderMobileShared: React.FC = () => {
    return (
        <div className="flex items-center justify-between border-b border-border bg-surface px-small py-vsmall md:px-medium">
            <div className="flex items-center gap-xsmall">
                <Logo href={routes.app.index} inApp />
            </div>
            <div className="flex items-center gap-vsmall">
                <HeaderPinSharedPortfolioButton />
                <HeaderBackButton />
            </div>
        </div>
    );
};
